import React from "react";
import logo from "../../../assets/img/paykit _logo1.webp";
export default function AuthCard({ title, subtitle, children }) {
  return (
    <div className="w-full sm:max-w-[400px] max-w-[300px] items-center">
      <div className="md:relative left-0 bg-white md:rounded-lg rounded-t-[10px] flex flex-col gap-1 md:gap-2 shadow-2xl p-4 md:p-6 z-50 mx-auto w-full">
        <div className="flex flex-row items-center justify-center">
          <img src={logo} alt="paykit logo" className="h-12 w-12xl" />
        </div>
        {(title || subtitle) && (
          <div className="mt-3 mb-4 sm:mt-4 sm:mb-6">
            {title && (
              <div className="text-black font-semibold text-base sm:text-lg items-center justify-center ">
                {title}
              </div>
            )}
            {subtitle && <div>{subtitle}</div>}
          </div>
        )}
        {children}
      </div>
    </div>
  );
}
